<div class="flat-btn btn-with-theme" [ngClass]="theme">
    <button mat-flat-button class="btn" [type]="type" [color]="color" [disabled]="disabled" [ngClass]="{'uc': uppercase}" [ngStyle]="{'fontWeight': fontWeight}">
        {{text}}
    </button>
</div>